import React from 'react';
import { Recipe } from '../../types/api/entities/recipe';
import { mediaQuery } from '../../util/ui';
import TimerIcon from 'mdi-react/TimerIcon';
import StarIcon from 'mdi-react/StarIcon';
import { Dispatch } from 'redux';
import { rateRecipe } from '../../store/actions/api/rate-recipe';
import { connect } from 'react-redux';
import { RatingModal } from './rating-modal';
import { withTranslation } from 'next-i18next';
import { WithTranslation as WithTranslationType } from 'next-i18next';

export interface OwnProps {
  recipe: Recipe;
  deactivateRatings?: boolean;
  deactivateAuthor?: boolean;
}

export interface DispatchProps {
  rateRecipe(value: number): void;
}

export type RecipeSummaryProps = OwnProps & DispatchProps & WithTranslationType;

interface RecipeSummaryState {
  isRatingModalActive: boolean;
}

class _RecipeSummary extends React.Component<RecipeSummaryProps, RecipeSummaryState> {
  constructor(props: RecipeSummaryProps) {
    super(props);
    this.state = {
      isRatingModalActive: false,
    };
  }

  public render() {
    const { recipe, deactivateAuthor, deactivateRatings } = this.props;
    const { isRatingModalActive } = this.state;
    const rating = Number(recipe.rating);
    const { name, pictureUrl } = recipe.creator || {
      name: '',
      pictureUrl: '',
    };
    return (
      <div className="container">
        {!deactivateAuthor && (
          <>
            <div className="creator">
              <div className="creator__image">
                {pictureUrl ? (
                  ''
                ) : (
                  <span className="creator__image-text">
                    {name
                      .split(' ')
                      .slice(0, 2)
                      .map((item) => item.charAt(0).toUpperCase())}
                  </span>
                )}
              </div>
              <span className="creator__name">{name}</span>
            </div>

            <hr />
          </>
        )}

        <div className="content">
          {recipe.yield ? (
            <div className="time">
              <span className="time__title">{this.props.t('Servings')}:</span>
              <div className="time__content">
                <span className="time__value">{recipe.yield}</span>
              </div>
            </div>
          ) : (
            ''
          )}

          {recipe.prepSeconds ? (
            <div className="time">
              <span className="time__title">{this.props.t('PrepTime')}:</span>
              <div className="time__content">
                <TimerIcon color="#bbbbbb" />
                <span className="time__value">{this.formatSeconds(recipe.prepSeconds || 0)}</span>
              </div>
            </div>
          ) : (
            ''
          )}

          {recipe.cookSeconds ? (
            <div className="time">
              <span className="time__title">{this.props.t('CookTime')}:</span>
              <div className="time__content">
                <TimerIcon color="#bbbbbb" />
                <span className="time__value">{this.formatSeconds(recipe.cookSeconds || 0)}</span>
              </div>
            </div>
          ) : (
            ''
          )}

          {deactivateRatings ? null : (
            <>
              <div className="rating">
                {isRatingModalActive && <div className="overlay" />}
                <span className="rating__count">
                  {this.props.t('RatingsWithCount', {
                    count: recipe.ratingCount,
                  })}
                </span>
                <div className="rating__stars" onMouseEnter={this.showRatingModal}>
                  {this.getStars()}
                  {isRatingModalActive && (
                    <div className="rating-modal">
                      <RatingModal onSubmit={this.rateRecipe} onCancel={this.hideRatingModal} />
                    </div>
                  )}
                </div>
                {recipe.userRating && (
                  <span className="rating__own">
                    {this.props.t('UserRating', { rating: recipe.userRating })}
                  </span>
                )}
                <span className="rating__value">{rating}</span>
              </div>

              <div className="rate">
                <button className="rate__button" onClick={this.showRatingModal}>
                  {this.props.t('RateNow')}
                </button>
              </div>
            </>
          )}
        </div>

        <style jsx>{`
          @media screen, print {
            .content {
              display: flex;
              align-items: center;
            }

            .time,
            .rating,
            .rate {
              text-align: center;
            }

            .time__title,
            .rating__count {
              font-family: var(--font-family-primary);
              font-size: 15px;
              color: #343434;
            }

            .time__content {
              margin-top: 8px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .time__value {
              margin-left: 5px;
              font-family: var(--font-family-secondary);
              font-weight: normal;
              line-height: 1.44;
              color: #1d1e1f;
            }

            .rating__value {
              font-family: var(--font-family-secondary);
              font-weight: normal;
              line-height: 1.42,
              color: #1d1e1f;
              font-size: 24px;
            }
          }

          @media screen {
            .rating-modal {
              z-index: 11;
            }

            .rating :global(.star-icon) {
              display: inline-block;
            }

            .container {
              padding: 20px 0 22px;
            }

            .creator {
              display: flex;
              flex-direction: column;
              align-items: center;
            }

            .creator__image {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 51px;
              height: 51px;
              border-radius: 50%;
              background-color: #f1f7fa;
              background-image: url(${pictureUrl || ''});
              background-size: cover;
              background-repeat: no-repeat;
              background-position: center;
            }

            .creator__image-text {
              font-size: 24px;
              font-family: var(--font-family-secondary);
              letter-spacing: normal;
              color: #acb4b9;
              cursor: default;
              user-select: none;
            }

            .creator__name {
              font-family: var(--font-family-secondary);
              font-size: 18px;
              line-height: 1.44;
              letter-spacing: normal;
              color: #1d1e1f;
              margin-top: 10px;
            }

            hr {
              display: none;
              border-top: 1px solid #d8d8d8;
              border-bottom: 0;
              margin-top: 40px;
              margin-bottom: 22px;
            }

            .content {
              flex-wrap: wrap;
            }

            .time,
            .rating,
            .rate {
              width: 50%;
            }

            .time__value {
              font-size: 18px;
            }

            .rating {
              margin-top: 20px;
            }

            .rating__stars {
              margin-top: 9px;
            }

            .rating__own {
              color: #343434;
              font-family: var(--font-family-primary);
              opacity: 0.5;
              font-size: 15px;
              display: block;
              text-align: center;
              margin-top: 5px;
              margin-bottom: 7px;
            }

            .rate__button {
              height: 32px;
              border-radius: 4px;
              border: solid 1px #131415;
              background-color: #fff;
              padding: 0 18.5px;
              cursor: pointer;
              font-family: var(--font-family-primary);
              color: #343434;
            }
          }

          @media screen and (pointer: fine) {
            .overlay {
              display: none;
            }

            .rate {
              display: none;
            }

            .rating__stars {
              position: relative;
            }

            .rating-modal {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }

          @media screen and (pointer: coarse) {
            .overlay {
              position: fixed;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              background-color: #131415;
              z-index: 10;
              opacity: 0.4;
            }

            .content {
              position: relative;
            }

            .rating-modal {
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
            }
          }

          @media ${mediaQuery.Medium} {
            .content {
              flex-wrap: nowrap;
            }

            .time,
            .rating,
            .rate {
              width: 100%;
            }

            .rating {
              margin: 0;
            }
          }

          @media ${mediaQuery.ExtraLarge} {
            .creator__image {
              width: 83px;
              height: 83px;
            }

            .creator__name {
              margin-top: 15px;
            }

            hr {
              display: block;
              margin-bottom: 0;
            }

            .time__value {
              font-size: 24px;
            }

            .content {
              flex-direction: column;
            }

            .time,
            .rating,
            .rate {
              width: 100%;
              margin-top: 29px;
            }
          }

          @media print {
            .container {
              border: solid 1px #131415;
              padding: 28px 65px 19px 72px;
            }

            .creator,
            hr,
            .rate {
              display: none;
            }

            .content {
              justify-content: space-between;
            }

            .rating__stars {
              margin-top: 5px;
            }

            .time,
            .rating,
            .rate {
              width: 100%;
            }

            .time__value {
              font-size: 24px;
            }
          }
        `}</style>
      </div>
    );
  }

  private readonly rateRecipe = (value: number) => {
    this.props.rateRecipe(value);
    this.hideRatingModal();
  };

  private readonly showRatingModal = () => {
    this.setState({ isRatingModalActive: true });
  };

  private readonly hideRatingModal = () => {
    this.setState({ isRatingModalActive: false });
  };

  private readonly getStars = () => {
    const result: JSX.Element[] = [];
    const { recipe } = this.props;
    const rating = recipe.userRating || Number(recipe.rating);
    const color = recipe.userRating ? '#057aff' : '#ffc900';

    for (let i = 1; i <= 5; i++) {
      result.push(
        <StarIcon
          key={i}
          color={rating >= i ? color : '#d8d8d8'}
          size="25px"
          className="star-icon"
        />,
      );
    }

    return result;
  };

  private formatSeconds(input: number): string {
    const h = Math.floor(input / 3600);
    const m = Math.floor((input % 3600) / 60);
    const pad = (x: number) => (x < 10 ? '0' + x : x);
    return `${pad(h)}:${pad(m)}`;
  }
}

function mapDispatchToProps(dispatch: Dispatch, props: OwnProps): DispatchProps {
  return {
    rateRecipe: (value) => dispatch(rateRecipe(props.recipe.id, value)),
  };
}

export const RecipeSummary = withTranslation()(
  connect(undefined, mapDispatchToProps)(_RecipeSummary),
);
